import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_HISTORY, UPDATE_HISTORY} from 'admin/gql/History.gql'

export default (itemType, itemId) => {
  const variables = {itemType, itemId}

  const {
    data: {history = []} = {},
    error: getError,
    loading: getLoading,
    refetch
  } = useQuery(GET_HISTORY, {variables, skip: !itemId})

  const [update, {error: updateError, loading: updateLoading}] = useMutation(UPDATE_HISTORY, {
    variables,
    refetchQueries: [{query: GET_HISTORY, variables}]
  })

  return {
    history,
    errors: getError || updateError || {},
    loading: getLoading || updateLoading,
    update,
    refetch
  }
}
